import Errors from './errors';

export default class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data) {
        this.init(data);
        this.errors = new Errors();
    }

    init(data) {
        this.originalData = data;

        for (let field in data) {
            this[field] = data[field];
        }

    }


    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this) {
            if(this.hasOwnProperty(property)) {
                data[property] = this[property];
            }

        }

        return data;
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            this[field] = '';
        }

        this.errors.clear();
    }


    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url) {
        return this.submit('post', url);
    }


    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit('put', url);
    }


    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit('patch', url);
    }


    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit('delete', url);
    }


    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url) {
        return new Promise((resolve, reject) => {
            axios[requestType](url, this.data())
                .then(response => {
                    console.log(response);
                    this.onSuccess(response.data);

                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                    this.onFail(error.response.data);

                    reject(error.response.data);
                });
        });
    }


    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {


    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        console.log(errors);
        this.errors.record(errors);
    }

    sanitizeValue(fd) {
        console.log('sanitize');
        fd = fd.replace(/[\s]+/g, ' ');
        fd = fd.trim();
        /*if(fd.charAt(2) != ' ') {
            fd = [fd.slice(0,2), ' ', fd.slice(2)].join('');
        }*/
        return fd;
    }
}